import React from 'react';
import './ProfileSection.css';

const ProfileSection = ({ 
    content,
    profilePicture = "https://via.placeholder.com/400x400/36454F/A8A2C7?text=JXLES",
    stats = {
        tracksProduced: 12,
        yearsActive: 3,
        collaborations: 8,
        releases: 4
    },
    skills = [
        "Electronic Production", "Sound Design", "Synthwave", "Ambient Music",
        "Mixing & Mastering", "Live Performance", "Audio Programming", "Digital Art"
    ]
}) => {
    // Use CMS content if available, otherwise fallback to defaults
    const bio = content?.data?.bio || "Welcome to the sonic world of JXLES - where electronic beats meet ethereal melodies, and digital soundscapes come alive.";
    const profileImage = content?.data?.photo || profilePicture;
    const achievements = content?.data?.achievements || [];

    return (
        <section className="profile-section">
            <div className="profile-section__container">
                <div className="profile-section__content">
                    <div className="profile-section__image-container">
                        <div className="profile-section__image-frame">
                            <img 
                                src={profileImage} 
                                alt="JXLES Profile" 
                                className="profile-section__image" 
                            />
                            <div className="profile-section__image-overlay"></div>
                        </div>
                    </div>

                    <div className="profile-section__info">
                        <div className="profile-section__header">
                            <h2 className="profile-section__title">
                                <span className="profile-section__title-prefix">PILOT:</span> CYPHER
                            </h2>
                            <p className="profile-section__subtitle">Audio Combat Specialist</p>
                            <div className="profile-section__status">
                                <div className="profile-section__status-dot"></div>
                                Status: Online & Operational
                            </div>
                        </div>

                        <div className="profile-section__bio">
                            <h3 className="profile-section__bio-title">Mission Brief</h3>
                            <p className="profile-section__bio-text">{bio}</p>
                        </div>

                        <div className="profile-section__stats">
                            <div className="profile-section__stat">
                                <span className="profile-section__stat-value">{stats.tracksProduced}</span>
                                <span className="profile-section__stat-label">Tracks Produced</span>
                            </div>
                            <div className="profile-section__stat">
                                <span className="profile-section__stat-value">{stats.yearsActive}</span>
                                <span className="profile-section__stat-label">Years Active</span>
                            </div>
                            <div className="profile-section__stat">
                                <span className="profile-section__stat-value">{stats.collaborations}</span>
                                <span className="profile-section__stat-label">Collaborations</span>
                            </div>
                            <div className="profile-section__stat">
                                <span className="profile-section__stat-value">{stats.battleWins}</span>
                                <span className="profile-section__stat-label">Battle Wins</span>
                            </div>
                        </div>

                        <div className="profile-section__skills">
                            <h3 className="profile-section__skills-title">Combat Specializations</h3>
                            <div className="profile-section__skills-grid">
                                {skills.map((skill, index) => (
                                    <span key={index} className="profile-section__skill">
                                        {skill}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProfileSection;